import styled from "styled-components";

export const ListPage = styled.div`
  width: 100%;
  min-width: 0;
  padding: 16px;

  @media (max-width: 767px) {
    padding: 8px;
  }
`;

export const ChartsGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  @media (max-width: 1360px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const ChartPanel = styled.section`
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe4ea;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(31, 41, 55, 0.05);
`;

export const ChartHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 42px;
  padding: 10px 12px;
  border-bottom: 1px solid #eef1f4;
  background: #fbfcfd;
`;

export const ChartTitle = styled.h3`
  margin: 0;
  color: #263241;
  font-size: 13px;
  font-weight: 700;
`;

export const ChartCanvas = styled.div`
  width: 100%;
  height: 205px;
  padding: 4px;
`;

export const ChartEmpty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #8a94a3;
  font-size: 12px;
`;

export const BillableCell = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  color: ${({ $billable }) => ($billable ? "#92400e" : "#6b7280")};
  font-weight: 600;

  &::before {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${({ $billable }) => ($billable ? "#d97706" : "#9ca3af")};
    content: "";
  }
`;

export const TableLink = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: #1c578f;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  text-align: left;

  &:hover,
  &:focus {
    color: #123f69;
  }
`;

export const MobileCardHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const MobileCardOverview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  min-width: 0;
`;

export const MobileCardDate = styled.span`
  justify-self: end;
  color: #4b5563;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

export const MobileCardMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 14px;
  min-width: 0;
`;

export const MobileCardMetric = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;

  .ant-tag {
    min-width: 0;
    max-width: 100%;
    margin-right: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const MobileCardMetricLabel = styled.span`
  flex: 0 0 auto;
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;

  &::after {
    content: ":";
  }
`;

export const MobileCardMetricValue = styled.span`
  min-width: 0;
  overflow: hidden;
  color: #1f2937;
  font-size: 11px;
  font-weight: 700;
  line-height: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MobileCardTitle = styled(TableLink)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
